import { wappPoolArrayView, wappPoolView } from './wapprunnerPool.reducer'
import { removeFromWappPool } from './wapprunnerPool.ops'
import { stageIsSatisfyingCondition, WappCondition, WappStage } from '../common'

export const getWappSession = (wappSessionId: string) =>
  wappPoolView()[wappSessionId]

export const getWappSessions = () => Object.values(wappPoolView())

export const getWappSessionsByWappId = (wappId: string) =>
  Object.values(wappPoolView()).filter(
    ({ wappId: sessionWappId }) => sessionWappId === wappId,
  )

export const getWappSessionsByWisId = (wisId: string) =>
  Object.values(wappPoolView()).filter(
    ({ wisId: sessionWisId }) => sessionWisId === wisId,
  )

export const getWappSessionByWappIdAndWisId = (
  messageWappId: string,
  messageWisId?: string,
) =>
  wappPoolArrayView().find(
    ({ wappId, wisId }) => wappId === messageWappId && wisId === messageWisId,
  )

export const findRunningWapp = (wappSessionId: string) => {
  const wapp = wappPoolView()[wappSessionId]
  return wapp?.stage === WappStage.RUNNING ? wapp : null
}

export const findConnectedWapp = (wappSessionId: string) => {
  const wapp = wappPoolView()[wappSessionId]
  return stageIsSatisfyingCondition(WappCondition.RECEIVE_MESSAGE, wapp?.stage)
    ? wapp
    : null
}

export const proneRedundantWapps = () => {
  wappPoolArrayView()
    .filter(
      ({ wappSessionId }) => !window.document.getElementById(wappSessionId),
    )
    .forEach(({ wappSessionId }) => removeFromWappPool(wappSessionId))
}
